module.exports = __webpack_public_path__ + "static/media/pdmo_logo.918cc5a7.png";